export default __webpack_public_path__ + "static/winter-holidays_2-d598feff07836914d459203c0a385338.png";